var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0524 4.17189L8.33318 3.63136L6.67058 0.260748C6.62517 0.168463 6.55047 0.0937555 6.45818 0.0483453C6.22674 -0.0659126 5.94548 0.0293023 5.82976 0.260748L4.16716 3.63136L0.447926 4.17189C0.345387 4.18653 0.251637 4.23487 0.17986 4.30812C0.0930851 4.39731 0.0452682 4.5173 0.0469162 4.64172C0.0485643 4.76615 0.0995424 4.88483 0.188649 4.97169L2.87957 7.59523L2.24382 11.2998C2.22892 11.386 2.23845 11.4746 2.27135 11.5557C2.30425 11.6367 2.3592 11.7069 2.42996 11.7583C2.50072 11.8097 2.58447 11.8402 2.67171 11.8464C2.75894 11.8527 2.84617 11.8343 2.92351 11.7935L6.25017 10.0445L9.57683 11.7935C9.66765 11.8418 9.77312 11.8579 9.8742 11.8404C10.1291 11.7964 10.3005 11.5547 10.2565 11.2998L9.62078 7.59523L12.3117 4.97169C12.3849 4.89991 12.4333 4.80616 12.4479 4.70362C12.4875 4.44728 12.3088 4.20997 12.0524 4.17189Z",
    fill: "#F2C403"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaractive);
export default __webpack_public_path__ + "static/media/staractive.411db8d8ad1d397d1c3d77ee09f0e65b.svg";
export { ForwardRef as ReactComponent };